module.exports = __webpack_public_path__ + "assets/img/1_540.16fd7a53.jpg";